// extracted by mini-css-extract-plugin
export var backgroundImage = "Billboard-module--backgroundImage--5f679";
export var billboard = "Billboard-module--billboard--4795d";
export var brightBlue = "Billboard-module--brightBlue--a27bf";
export var contentContainer = "Billboard-module--contentContainer--e4442";
export var contentWrapper = "Billboard-module--contentWrapper--62c02";
export var darkBlue = "Billboard-module--darkBlue--7877f";
export var horizontalCenter = "Billboard-module--horizontalCenter--07286";
export var horizontalLeft = "Billboard-module--horizontalLeft--0f021";
export var horizontalRight = "Billboard-module--horizontalRight--7aea0";
export var lightBlue = "Billboard-module--lightBlue--95a1d";
export var logoRail = "Billboard-module--logoRail--c3818";
export var seaGreen = "Billboard-module--seaGreen--6a4ec";
export var veilOfDarkness = "Billboard-module--veilOfDarkness--082d9";
export var verticalBottom = "Billboard-module--verticalBottom--4c71e";
export var verticalMiddle = "Billboard-module--verticalMiddle--1a32d";
export var verticalTop = "Billboard-module--verticalTop--1514b";
export var widthFull = "Billboard-module--widthFull--ff418";
export var widthHalf = "Billboard-module--widthHalf--08326";
export var widthOnethird = "Billboard-module--widthOnethird--a147c";
export var widthTwothirds = "Billboard-module--widthTwothirds--a1c2e";